import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OrganizationContextState {
  selectedOrganizationId: string | null;
}

const initialState: OrganizationContextState = {
  selectedOrganizationId: null,
};

const organizationContextSlice = createSlice({
  name: 'organizationContext',
  initialState,
  reducers: {
    setSelectedOrganizationId: (state, action: PayloadAction<string | null>) => {
      state.selectedOrganizationId = action.payload;
    },
  },
});

export const { setSelectedOrganizationId } = organizationContextSlice.actions;
export default organizationContextSlice.reducer;
